/** Joylance's handwritten signature block — closes every Insight article and
 * Spotlight story. The image is admin-replaceable (Site settings → signature_url). */
import { useEffect, useState } from "react";
import api from "@/lib/api";

let cachedSettings = null; // fetched once per session

// Bundled with the frontend build so the signature always ships to every
// environment (preview + production). An admin-uploaded replacement, stored
// in site settings, overrides this default when present.
const DEFAULT_SIGNATURE = "/brand/signature.png";

export const SignatureBlock = ({ dark = false, center = true, className = "" }) => {
  const [signatureUrl, setSignatureUrl] = useState(cachedSettings?.signature_url || DEFAULT_SIGNATURE);

  useEffect(() => {
    if (cachedSettings) return;
    api
      .get("/public/site-settings")
      .then((r) => {
        cachedSettings = r.data || {};
        setSignatureUrl(cachedSettings.signature_url || DEFAULT_SIGNATURE);
      })
      .catch(() => {});
  }, []);

  return (
    <div
      className={`flex flex-col ${center ? "items-center text-center" : "items-start"} ${className}`}
      data-testid="signature-block"
    >
      {signatureUrl && (
        <img
          src={signatureUrl}
          alt="Joylance — handwritten signature"
          className="h-24 sm:h-28 w-auto object-contain select-none"
          draggable={false}
          onError={(e) => {
            if (e.target.src !== window.location.origin + DEFAULT_SIGNATURE) e.target.src = DEFAULT_SIGNATURE;
          }}
          data-testid="signature-image"
        />
      )}
      <div className={`${signatureUrl ? "mt-2" : ""} font-display text-sm font-semibold tracking-wide ${dark ? "text-[#FDFBF5]" : "text-[#2A1810]"}`}>
        Joylance Chapman-George
      </div>
      <div className={`mt-0.5 text-xs ${dark ? "text-[#F0E6D2]/60" : "text-[#6B5944]"}`}>
        Founder, The CCS Approach
      </div>
      <div className={`mt-3 text-[10px] uppercase tracking-[0.3em] font-bold ${dark ? "text-[#E7B54D]" : "text-[#C28A2E]"}`}>
        Communicate • Collaborate • Serve
      </div>
    </div>
  );
};

export default SignatureBlock;
